module.exports = __webpack_public_path__ + "static/media/Invoice Amortisation.a277b193.svg";